import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpService } from '../http.service';
import { ServiceBase } from '../servicebase';
import { JobTitleFamilyModel } from '../models/hiring/jobTitleFamily.model';
import { Filter } from 'services/models/odata/filter';
import { QueryParams } from 'services/models/odata/queryParams';
import { Response } from 'services/models/response';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class JobTitleFamilyService extends ServiceBase<JobTitleFamilyModel> {
  constructor(http: HttpService) {
    super('jobtitlefamily', http, environment.apiUrl);
  }

  createEntity(input: any): JobTitleFamilyModel {
    return JobTitleFamilyModel.create(input);
  }

  override list(
    params: QueryParams,
    disableLoading: boolean = false
  ): Observable<Response<JobTitleFamilyModel[]>> {
    const defaultSelect = ['id', 'enable', 'creationDate'];
    params.select = [
      ...params.select.filter(field => !defaultSelect.includes(field)),
      ...defaultSelect,
    ];

    const query = this.createBuildQuery(params);
    return this.http
      .get(`${this.endpoint}/odata${query}`, undefined, this.baseUrl, null, disableLoading)
      .pipe(
        map(res => {
          const response = new Response<JobTitleFamilyModel[]>();
          const rawList = Array.isArray(res.body) ? res.body : (res.body?.value ?? []);
          response.data = rawList.map((item: any) => this.createEntity(item));
          response.count = res.headers.get('x-count');
          return response;
        })
      );
  }

  listByCompanyGroupId(companyGroupId: string): Observable<Response<JobTitleFamilyModel[]>> {
    const filters = [];
    filters.push(Filter.buildFilter('companyGroupId', companyGroupId));
    filters.push(Filter.buildFilter('enable', true));

    const params = {
      select: ['name', 'id'],
      orderBy: 'name',
      orderByOrder: 'asc',
      filter: Filter.multEquals(filters),
    } as QueryParams;

    return this.list(params, true);
  }
}
